import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import androidService from "../../services/mobile/androidService";
import faArrowLeft from "../../fontawesome/pro-regular-svg-icons/faArrowLeft";
import faArrowRightFromBracket from "../../fontawesome/pro-regular-svg-icons/faArrowRightFromBracket";
import LogoutButton from "../../components/buttons/logoutButton";

export default function SettingsPage() {
    const navigate = useNavigate();

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
            <div
                style={{
                    background: "#0D6EFD",
                    color: "white",
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                }}
            >
                <button className="btn btn-link p-0 text-white" onClick={() => navigate(-1)}>
                    <FontAwesomeIcon icon={faArrowLeft} size="lg" />
                </button>
                <span className="ms-2 fw-bold fs-5">Настройки</span>
            </div>
            <div style={{ flexGrow: 1 }} />
            <div className="p-3">
                <LogoutButton caption="Сменить аккаунт" onClick={() => androidService.performLogout()} />
            </div>
        </div>
    );
}
